import { Log, Level, Logger } from 'ng2-logger';
import ApiClient from './alms-api';
import { Notification } from '../components/notification/main';
import Translator from '../core/i18n';

let _apiClient: ApiClient;
const token: any = localStorage.getItem('access_token');
const T = Translator.create();
const _logger = Log.create('Polling-Service');

export class QrPollingService {
    constructor() {
        _apiClient = new ApiClient();
    }

    public async RequestGetAttendaceListsAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/class/getattendances', params, token)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }

    public async RequestDeleteAttendace(params: any) {
        return _apiClient.RequestAsync('POST', 'api/class/deleteattendances', params, token)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }


    public async RequestCreateQrCodeForAttendance(params: any) {
        return _apiClient.RequestAsync('POST', 'api/class/createattendance', params, token)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }

    public async RequestGenerateQrCode(params: any) {
        return _apiClient.RequestAsync('POST', 'api/class/generateqrcode', params, token)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }

    public async RequestAttendanceStudentsList(params: any) {
        return _apiClient.RequestAsync('POST', 'api/class/getattendanceliststudents', params, token)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }

    public async RequestAddStudentAttendance(params: any) {
        return _apiClient.RequestAsync('POST', 'api/class/addstudenttoattendance', params, token)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }

    public async RequestRemevoStudentAttendance(params: any) {
        return _apiClient.RequestAsync('POST', 'api/class/removestudentfromattendance', params, token)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }

    public async RequestGetRefreshAttendanceUser() {
        return _apiClient.RequestAsync('GET', 'api/class/refreshattendaces', token)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }

    public async RequestGetClassess(params: any) {
        return _apiClient.RequestAsync('POST', 'api/class/classes', params, token)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }

    public async RequestGetActiveAttendance(params: any) {
        return _apiClient.RequestAsync('POST', 'api/class/getclassactiveattendance', params.classId, token)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }

    public async RequestEndAttendance(params: any) {
        return _apiClient.RequestAsync('POST', 'api/class/endattendance', params, token)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }
}